import Header from "../../../../layouts/Header"
import { styled, createTheme, ThemeProvider } from "@mui/material/styles"
import { Box, Button } from "@mui/material"
import CustomTooltip from "../../../../components/ToolTip"

import BackIcon from "../../../../components/BackIcon"

import { useLocation, useNavigate } from "react-router-dom"
import CustomTextFieldReadable from "../../../../components/CustomTextFieldReadable"
import CustomBackdrop from "../../../../components/CustomBackdrop"
import { useEffect, useState } from "react"
import { useMutation, useQuery } from "@tanstack/react-query"
import fetchwrapper from "../../../../services/interceptors/fetchwrapper"
import normalFormatDate from "../../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../../utils/date/HHMMSSFormatHour"
import DatagridPickingDetalle from "../../components/DatagridPickingDetalle"
import GrabarIcon from "../../../../assets/iconos/Grabar.ico"

const StyledRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginTop: theme.spacing(8),
  flexGrow: 1,
  padding: "0 16px",
  height: "100vh",
}))

const theme = createTheme({
  palette: {
    primary: {
      main: "#196C87",
    },
    secondary: {
      main: "#196C87", // Cambia el color secundario a verde azulado
    },
  },
})

const ContainerCabecera = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "repeat(12, 1fr)",
  gridTemplateRows: "auto auto auto",
  gridTemplateAreas: `
        "IPicking IPicking IPicking IFecha IFecha IFecha IEstado IEstado IEstado ITipo ITipo ITipo"
        "IFechaRealizar IFechaRealizar IFechaRealizar IFechaRealizar IHoraRealizar IHoraRealizar IHoraRealizar IHoraRealizar IUsuario IUsuario IUsuario IUsuario"
        "IComentario IComentario IComentario IComentario IComentario IComentario IComentario IComentario IComentario IComentario IComentario IComentario"
      `,
  gap: "8px",
  alignItems: "center",
}))

const IPicking = styled(Box)({
  gridArea: "IPicking",
})

const IFecha = styled(Box)({
  gridArea: "IFecha",
})

const IEstado = styled(Box)({
  gridArea: "IEstado",
})
const ITipo = styled(Box)({
  gridArea: "ITipo",
})
const IUsuario = styled(Box)({
  gridArea: "IUsuario",
})

const IFechaRealizar = styled(Box)({
  gridArea: "IFechaRealizar",
})

const IHoraRealizar = styled(Box)({
  gridArea: "IHoraRealizar",
})

const IComentario = styled(Box)({
  gridArea: "IComentario",
})

const CierrePickingVer = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [picking, setPicking] = useState({
    cabecera: {},
    detalle: [],
  })

  const {
    data: fetchedFilteredPicking = [],
    isError: isLoadingFilteredPickingError,
    isFetching: isFetchingFilteredPicking,
    isLoading: isLoadingFilteredPicking,
    refetch: refetchFilteredPicking,
  } = useGetFilteredPicking()

  function useGetFilteredPicking() {
    return useQuery({
      queryKey: ["fetchedFilteredPickingVerCrear"],
      queryFn: async () => {
        const options = {
          method: "POST",
          body: JSON.stringify({
            sgapicking: location?.state?.sgapicking,
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
        let response = await fetchwrapper(`/CierrePicking/getSpecificPicking`, options)
        response = await response.json()

        return response.data
      },
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    })
  }

  useEffect(() => {
    refetchFilteredPicking()
  }, [location?.state?.sgapicking])

  useEffect(() => {
    if (Object.keys(fetchedFilteredPicking).length > 0) {
      setPicking({
        cabecera: fetchedFilteredPicking?.cabecera,
        detalle: fetchedFilteredPicking?.detalle,
      })
    }
  }, [fetchedFilteredPicking])

  const { mutateAsync: createCierrePicking, isPending: isCreatingCierrePicking } = useCreateCierrePicking()

  function useCreateCierrePicking() {
    return useMutation({
      mutationFn: async () => {
        // send api update request here
        const options = {
          method: "POST",
          body: JSON.stringify({
            picking: picking.cabecera?.sgapicking,
            estadoPicking: picking.cabecera?.sgapickstatus,
            detalle: picking.detalle,
          }),
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }

        let response = await fetchwrapper("/CierrePicking/saveCierrePicking", options)
        response = await response.json()

        return response
      },
      onSuccess: () => {
        alert("Cierre de picking creado con éxito")
        navigate(0)
      },
      onError: () => {
        alert("No se pudo crear el cierre de picking")
      },
    })
  }

  const handleSaving = () => {
    createCierrePicking()
  }
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div className="main main-app p-3 p-lg-4">
        <BackIcon />
        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px", padding: "5px" }}>
            <CustomTooltip title={"Ejecutar"}>
              <Button onClick={handleSaving}>
                <img src={GrabarIcon} alt="Guardar" style={{ width: "40px" }} />
              </Button>
            </CustomTooltip>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "0 30px 30px 30px",
            fontSize: "25px",
          }}
        >
          <b>Cierre de Picking</b>
        </div>
        <CustomBackdrop isLoading={isLoadingFilteredPicking || isFetchingFilteredPicking || isCreatingCierrePicking} />

        <Box className={StyledRoot}>
          <ContainerCabecera>
            <IPicking>
              <CustomTextFieldReadable label="Picking" value={picking?.cabecera?.sgapicking} />
            </IPicking>
            <IFecha>
              <CustomTextFieldReadable label="Fecha" value={normalFormatDate(picking?.cabecera?.sgafecpick)} />
            </IFecha>
            <IEstado>
              <CustomTextFieldReadable label="Estado" value={picking?.cabecera?.sgapickstatus} />
            </IEstado>
            <ITipo>
              <CustomTextFieldReadable label="Tipo" value={picking?.cabecera?.sgapicktipo} />
            </ITipo>
            <IUsuario>
              <CustomTextFieldReadable label="Usuario" value={picking?.cabecera?.sgausupicking} />
            </IUsuario>
            <IFechaRealizar>
              <CustomTextFieldReadable
                label="Fecha a Realizar"
                value={normalFormatDate(picking?.cabecera?.sgafecpicking)}
              />
            </IFechaRealizar>
            <IHoraRealizar>
              <CustomTextFieldReadable
                label="Hora a Realizar"
                value={normalFormatHour(picking?.cabecera?.sgahorpicking)}
              />
            </IHoraRealizar>
            <IComentario>
              <CustomTextFieldReadable label="Comentario" value={picking?.cabecera?.sgapickdescri} />
            </IComentario>
          </ContainerCabecera>
          <br />
          <br />
          <DatagridPickingDetalle
            fetchedInfo={picking?.detalle}
            isLoadingInfoError={isLoadingFilteredPickingError}
            isLoadingInfo={isLoadingFilteredPicking}
            isFetchingInfo={isFetchingFilteredPicking}
            columnsTable={[
              {
                accessorKey: "sgasolegrfac",
                header: "Factura Solicitud/Egreso",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "clicodigo",
                header: "Código Cliente",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "clinombre",
                header: "Nombre Cliente",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "artcodigo",
                header: "Código Artículo",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "artdescri",
                header: "Nombre Artículo",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "sgacansolfac",
                header: "Cantidad Pendiente",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "sgacanpicking",
                header: "Cantidad Picking",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "pascodigo",
                header: "Código Pasillo",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "izoncodigo",
                header: "Código Zona",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "izondescripcion",
                header: "Descripción Zona",
                size: 150,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "bahcodigo",
                header: "Código Bahía",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "bahdescripcion",
                header: "Descripción Bahía",
                size: 150,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "poscodigo",
                header: "Código Posición",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "posdescripcion",
                header: "Descripción Posición",
                size: 150,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "nivcodigo",
                header: "Código Nivel",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "nivdescripcion",
                header: "Descripción Nivel",
                size: 150,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "embcodigo",
                header: "Código Embalaje",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "toncodigo",
                header: "Código Tonnel",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "embpieza",
                header: "Pieza Embalaje",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
              {
                accessorKey: "embmetros2",
                header: "Metros Cuadrados",
                size: 100,
                Cell: ({ cell }) => <span>{cell.getValue()}</span>,
              },
            ]}
          />
        </Box>
      </div>
    </ThemeProvider>
  )
}

export default CierrePickingVer
